// data/projects.ts
// Contenido ORIGINAL en español. Traducciones: data/projects.en.ts (usa getProjects/getProject).
import type { Lang } from "@/lib/i18n/config"
import { projectTranslations } from "./projects.en"

export const projects = [
  {
  slug: "brahim-diaz",
  title: "Brahim Díaz",
  video: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/brahim-diaz-oVDpWNAUiT0lgMCyHaGq2cnLaBNTvQ.mp4",
  poster: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/brahim-diaz-poster-uRFFMrLpmkLp8nOHDgDWkqaY94gMiv.jpg",
  href: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/brahim-diaz-oVDpWNAUiT0lgMCyHaGq2cnLaBNTvQ.mp4",
  sections: [
    {
      title: "",
      items: [
        "Sony Pictures preparó una pieza promocional única para el estreno de Bad Boys: Ride or Die, reuniendo a Will Smith con tres figuras españolas muy influyentes: El Rubius, Mangel y Brahim Díaz, jugador del Real Madrid y campeón de Europa.",
        "Mi papel fue colaborar en la producción audiovisual del anuncio, asegurando que la experiencia fuera fluida, profesional y al nivel de una campaña internacional.",
        "El resultado fue un spot viral, compartido por los propios protagonistas y distribuido a nivel nacional.",
      ],
    },
    {
      title: "EL OBJETIVO DEL PROYECTO",
      items: [
        "El objetivo de Sony era crear un contenido que conectara:",
        "• cine",
        "• cultura digital",
        "• deporte profesional",
        "• audiencia joven",
        "Una colaboración inesperada y llamativa para amplificar el alcance de la película.",
        "La aparición de Brahim Díaz fue clave: su conexión con el público joven y su impacto mediático tras su temporada con el Real Madrid aportaban una capa extra de relevancia.",
      ],
    },
    {
      title: "MI PAPEL EN EL PROYECTO",
      items: [
        "Colaboré en el proceso de producción para asegurar:",
        "✓ Coordinación audiovisual — Soporte técnico y logístico durante el rodaje.",
        "✓ Cohesión narrativa y visual — Supervisión de planos, continuidad y estética acorde al tono cinematográfico.",
        "✓ Dirección de apoyo — Acompañamiento en la puesta en escena y la comunicación entre talento y equipo.",
        "✓ Control de flujo técnico — Luces, cámara, sonido y tiempos, manteniendo eficiencia y calidad.",
        "✓ Preparación del entorno y composición — Garantizar que cada toma potenciara a los protagonistas y encajara en la narrativa.",
        "Aunque el vídeo es breve, la producción requirió precisión, ritmo y profesionalidad debido al talento involucrado.",
      ],
    },
    {
      title: "SOBRE EL SPOT",
      items: [
        "En el vídeo:",
        "• Will Smith discute en una mansión con El Rubius y Mangel.",
        "• De repente, Brahim Díaz aparece y pregunta si Will está listo para la final de Wembley.",
        "La escena juega con humor, espontaneidad y choque cultural.",
        "La pieza fue diseñada para ser:",
        "• rápida",
        "• viral",
        "• multiplataforma",
        "• compartible en redes sociales",
        "Y cumplió exactamente ese propósito.",
      ],
    },
    {
      title: "ENTREGA FINAL",
      items: [
        "El proyecto incluyó:",
        "Spot final para redes y promoción. Formato corto, ágil y muy viral.",
        "Distribución vía talentos. El Rubius, Mangel y Brahim lo publicaron en sus redes, multiplicando alcance.",
        "Impacto mediático. Medios como Diario Sur y otros periódicos nacionales hablaron del vídeo.",
      ],
    },
    {
      title: "RESULTADO",
      items: [
        "La pieza tuvo un impacto notable:",
        "• miles de comentarios y compartidos",
        "• difusión orgánica a través de talentos con millones de seguidores",
        "• cobertura en prensa nacional",
        "• fortalecimiento de la estrategia promocional de Sony en España",
        "• visibilidad internacional por parte del propio Will Smith",
        "El proyecto demostró la importancia de unir celebridades, deporte y cultura digital en una campaña audiovisual.",
      ],
    },
  ],
},
{
  slug: "omar-montes",
  title: "Omar Montes",
  video: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/omar-montes-FtJaM4v1WwcGYflEUuLvMpVrEEuGGM.mp4",
  poster: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/omar-montes-poster-unSyjbcKFfSVYifFYX2FBUKpXa2MpO.jpg",
  href: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/omar-montes-FtJaM4v1WwcGYflEUuLvMpVrEEuGGM.mp4",
  sections: [
    {
      title: "",
      items: [
        "Omar Montes presentó su espectáculo “Illuminati Party” en el Palacio Vistalegre de Madrid, uno de los recintos más emblemáticos de la ciudad.",
        "Mi misión fue capturar la energía del concierto, la puesta en escena, la conexión con el público y la magnitud del evento, creando una pieza audiovisual potente, dinámica y llena de vida.",
        "El resultado es un vídeo que refleja la intensidad del show, el ambiente de la fiesta y la fuerza del artista sobre el escenario.",
      ],
    },
    {
      title: "EL OBJETIVO DEL PROYECTO",
      items: [
        "El contenido debía transmitir:",
        "✓ Energía y espectacularidad — Pantallas, luces, humo, bailarines y una puesta en escena masiva.",
        "✓ Conexión del artista con el público — Miradas, gestos y momentos icónicos del directo.",
        "✓ La esencia de la “Illuminati Party” — Un show que combina música, fiesta y visuales impactantes.",
        "✓ Contenido reutilizable para el artista — Para redes, comunicación, prensa y recap oficial.",
      ],
    },
    {
      title: "MI PAPEL EN EL PROYECTO",
      items: [
        "Me encargué de cubrir el concierto desde dentro del recinto, incluyendo:",
        "• grabación en 4K",
        "• movimientos dinámicos para acompañar la música",
        "• planos cercanos del artista",
        "• planos amplios del escenario y el público",
        "• transición entre zonas del recinto (pista, backstage, laterales)",
        "• capturas de luces, efectos y pirotecnia",
        "• edición rítmica al tempo de la música",
        "• corrección de color con estética concierto (neones, contraste, saturación equilibrada)",
        "• versión adaptada para redes",
        "El objetivo fue equilibrar espectáculo, emoción y ritmo, manteniendo un estilo cinematográfico.",
      ],
    },
    {
      title: "PROCESO DE GRABACIÓN",
      items: [
        "Durante el concierto:",
        "• trabajé entre el público y zonas permitidas para capturar la energía real",
        "• busqué planos cercanos que mostraran al artista en acción",
        "• grabé la interacción con invitados y público",
        "• capturé cambios de iluminación, humo, pantallas LED y efectos",
        "• realicé tomas generales para mostrar la magnitud del Vistalegre lleno",
        "• busqué momentos únicos: saltos, coros, gestos, complicidad",
        "El enfoque fue sumergir al espectador en la experiencia del concierto.",
      ],
    },
    {
      title: "ENTREGA FINAL",
      items: [
        "El proyecto incluyó:",
        "1 vídeo resumen principal. Ritmo rápido, montaje musical y estética vibrante.",
        "Piezas adaptadas a redes sociales. Extractos optimizados para Instagram, LinkedIn y otras plataformas.",
        "Corrección de color y música. Tratamiento visual coherente con la identidad de la marca de Omar.",
      ],
    },
    {
      title: "RESULTADO",
      items: [
        "Gracias al vídeo:",
        "• se potenció la imagen del artista y del propio evento",
        "• se generó contenido atractivo para RRSS y prensa",
        "• se transmitió la magnitud de la “Illuminati Party” en Madrid",
        "• se creó una pieza promocional para futuros conciertos",
      ],
    },
  ],
},
{
  slug: "rimmel-london",
  title: "Rimmel London",
  video: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/rimmel-london-aPVrTuDZhdN2EfmUZXjzJN64N5lMGq.mp4",
  poster: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/rimmel-london-poster-t5YoVhpE33nOd6aMNSLokc7R6FZIya.jpg",
  href: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/rimmel-london-aPVrTuDZhdN2EfmUZXjzJN64N5lMGq.mp4",
  sections: [
    {
      title: "",
      items: [
        "Rimmel London me encargó la cobertura y el aftermovie de una activación de marca pensada para poner a prueba su máscara de pestañas Megalift Waterproof en condiciones reales de agua.",
        "La protagonista fue la deportista y creadora de contenido Gisela Pulido, acompañada de un grupo de creadoras invitadas al evento.",
        "Mi trabajo fue capturar el reto acuático y convertirlo en una pieza de marca dinámica, pensada para redes sociales.",
      ],
    },
    {
      title: "EL OBJETIVO DEL PROYECTO",
      items: [
        "El vídeo debía demostrar, de forma visual y creíble, la resistencia al agua del producto:",
        "✓ Mostrar el reto en acción — El momento en el que el producto se somete a olas y agua a máxima intensidad.",
        "✓ Reforzar el mensaje de marca — Que la resistencia se viera, no solo se dijera.",
        "✓ Generar contenido nativo de redes — Un recap ágil, pensado para el consumo rápido en Instagram.",
      ],
    },
    {
      title: "MI PAPEL EN EL PROYECTO",
      items: [
        "Me encargué de la cobertura audiovisual completa del evento, incluyendo:",
        "• grabación en el propio espacio del reto de agua",
        "• planos de detalle del producto y del resultado sobre la piel",
        "• captura de la reacción y energía de las invitadas",
        "• edición ritmo recap, pensada para formato vertical",
        "• corrección de color acorde a la identidad de marca de Rimmel London",
        "• entrega optimizada para publicación en Instagram",
        "El reto era que el vídeo se sintiera auténtico y divertido, sin perder el foco publicitario.",
      ],
    },
    {
      title: "PROCESO DE GRABACIÓN",
      items: [
        "Durante la activación:",
        "• trabajé cerca del agua para no perder ningún momento del reto",
        "• prioricé planos que mostraran el antes y el después del maquillaje",
        "• capturé la interacción espontánea entre las creadoras",
        "• mantuve un ritmo ágil de grabación acorde al formato recap",
        "El resultado es una pieza corta, clara y con gancho desde el primer segundo.",
      ],
    },
    {
      title: "ENTREGA FINAL",
      items: [
        "El proyecto incluyó:",
        "1 vídeo recap principal. Formato vertical, ritmo ágil, listo para Reels.",
        "Corrección de color y edición de marca. Coherente con la identidad visual de Rimmel London.",
      ],
    },
    {
      title: "RESULTADO",
      items: [
        "El vídeo permitió a Rimmel London:",
        "• demostrar de forma visual la promesa de producto",
        "• generar contenido de marca protagonizado por una creadora relevante",
        "• disponer de una pieza directamente publicable en redes",
      ],
    },
  ],
},
{
  slug: "camara-de-comercio",
  title: "Cámara de Comercio",
  video: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/camara-de-comercio-v2-MHUeVJIHLxgmNPJgkMvQ6rsndafkMY.mp4",
  poster: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/camara-de-comercio-v2-poster-ZbRQboqj3Sm5GFgRqDfGeFBywMTsfd.jpg",
  href: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/camara-de-comercio-v2-MHUeVJIHLxgmNPJgkMvQ6rsndafkMY.mp4",
  sections: [
    {
      title: "",
      items: [
        "La Cámara de Comercio organizó un evento institucional que reunía empresas, ponentes y representantes del sector económico.",
        "Mi objetivo fue documentar la jornada con un enfoque profesional, claro y elegante, capturando tanto la esencia del encuentro como los momentos clave de la agenda.",
        "El resultado es un vídeo institucional que refleja la importancia del evento y la identidad de la organización.",
      ],
    },
    {
      title: "EL OBJETIVO DEL PROYECTO",
      items: [
        "El vídeo debía cumplir con tres necesidades principales:",
        "✓ Documentar el evento de forma profesional — Incluyendo ponencias, networking, asistentes y marca institucional.",
        "✓ Transmitir credibilidad y solidez — El contenido debía reflejar el tono formal y la relevancia de la institución.",
        "✓ Proporcionar contenido útil para comunicación — Piezas listas para redes, prensa y uso institucional.",
      ],
    },
    {
      title: "MI PAPEL EN EL PROYECTO",
      items: [
        "Me encargué de la cobertura completa, incluyendo:",
        "• grabación de ponencias y momentos clave",
        "• B-roll institucional (planos de asistentes, detalles y ambiente)",
        "• capturas de marca y elementos visuales",
        "• edición narrativa profesional",
        "• corrección de color elegante y neutra",
        "• música acorde al tono institucional",
        "• entregas para redes y archivo",
        "La prioridad fue mantener un estilo sobrio, limpio y coherente con la imagen de la Cámara de Comercio.",
      ],
    },
    {
      title: "PROCESO DE GRABACIÓN",
      items: [
        "Durante la jornada:",
        "• trabajé con discreción para no interrumpir el protocolo",
        "• capturé intervenciones importantes",
        "• documenté el networking y la participación de asistentes",
        "• realicé planos recurso para enriquecer la narrativa",
        "• aseguré estabilidad, claridad y consistencia visual",
        "Este tipo de eventos requiere sensibilidad institucional y comprensión del tono corporativo, manteniendo siempre respeto y profesionalidad.",
      ],
    },
    {
      title: "ENTREGA FINAL",
      items: [
        "El proyecto incluyó:",
        "1 vídeo resumen principal. Edición cinematográfica con narrativa clara y ritmo dinámico.",
        "Piezas adaptadas a redes sociales. Versión vertical optimizada para Instagram y TikTok.",
        "Corrección de color y música. Tratamiento visual coherente con la identidad de la marca.",
      ],
    },
    {
      title: "RESULTADO",
      items: [
        "El vídeo permitió a la Cámara de Comercio:",
        "• reforzar su comunicación visual",
        "• mostrar profesionalidad y dinamismo",
        "• disponer de contenido para instituciones, prensa y RRSS",
        "• reflejar el alcance y la relevancia del evento",
      ],
    },
  ],
},
{
  slug: "ifema",
  title: "IFEMA",
  video: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/ifema-M2z4wQuTl5xemnLUxjFrS4fx9J0Eq6.mp4",
  poster: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/ifema-poster-m2zfbFvOQ4XE2mEURnSbK3ByvgEIzh.jpg",
  href: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/ifema-M2z4wQuTl5xemnLUxjFrS4fx9J0Eq6.mp4",
  sections: [
    {
      title: "",
      items: [
        "IFEMA Madrid necesitaba una pieza audiovisual que reflejara la magnitud de sus eventos, la profesionalidad de su equipo y la experiencia que vive el público en cada feria, con un enfoque visual potente y alineado con una marca institucional de primer nivel.",
        "El objetivo era crear un vídeo corporativo dinámico, moderno y visualmente atractivo que pudiera utilizarse en web, redes sociales, presentaciones comerciales y comunicación interna.",
      ],
    },
    {
      title: "EL OBJETIVO DEL PROYECTO",
      items: [
        "El vídeo se diseñó con tres objetivos principales:",
        "✓ Reforzar la imagen de marca de IFEMA — Transmitir solidez, profesionalidad y liderazgo como uno de los principales recintos feriales de Europa.",
        "✓ Mostrar la experiencia real del evento — Reflejar la energía, el ambiente, el movimiento y la interacción entre expositores, visitantes y organización.",
        "✓ Generar confianza en expositores y partners — Que cualquier marca o profesional que vea el vídeo perciba a IFEMA como un entorno serio, bien organizado y de alto impacto para sus objetivos de negocio.",
        "✓ Proporcionar contenido reutilizable — Una pieza central adaptable a web corporativa, redes sociales, presentaciones comerciales y materiales promocionales.",
      ],
    },
    {
      title: "MI PAPEL EN EL PROYECTO",
      items: [
        "En este proyecto me encargué de:",
        "• diseño del enfoque visual y narrativo del vídeo",
        "• planificación de la grabación en entorno de evento real",
        "• grabación en directo durante la feria",
        "• dirección de planos para captar momentos clave de actividad, público e interacción",
        "• selección de localizaciones dentro del recinto para mostrar escala y ambiente",
        "• grabación de recursos (B-roll) de stands, público, detalles y movimiento",
        "• edición con ritmo dinámico y enfoque corporativo",
        "• corrección de color con estética limpia y profesional",
        "• entrega en formatos adaptados a web, redes sociales y presentaciones",
        "La idea fue transmitir escala, dinamismo y profesionalidad en una sola pieza audiovisual.",
      ],
    },
    {
      title: "PROCESO DE GRABACIÓN",
      items: [
        "Durante la sesión:",
        "• trabajamos en un entorno real de feria con alto flujo de personas",
        "• capturamos planos de ambiente general del recinto",
        "• grabamos interacción entre marcas, visitantes y organización",
        "• combiné planos abiertos para mostrar magnitud con planos detalle para humanizar la experiencia",
        "• cuidé una iluminación y estética acordes a un entorno corporativo de alto nivel",
        "• busqué transmitir movimiento, actividad y energía constante",
        "El resultado es una pieza que transmite la dimensión real de IFEMA y la experiencia que se vive dentro de sus eventos.",
      ],
    },
    {
      title: "ENTREGA FINAL",
      items: [
        "El proyecto incluyó:",
        "1 vídeo resumen principal. Ideal para web corporativa, presentaciones comerciales o uso institucional.",
        "Piezas adaptadas a redes sociales. Extractos optimizados para Instagram, LinkedIn y otros canales profesionales.",
        "Corrección de color y música. Tratamiento visual coherente con la identidad de marca de IFEMA.",
      ],
    },
    {
      title: "RESULTADO",
      items: [
        "El vídeo permitió a IFEMA:",
        "• reforzar su posicionamiento como recinto ferial de referencia",
        "• comunicar de forma visual el valor real de sus eventos",
        "• transmitir profesionalidad y confianza a marcas expositoras",
        "• disponer de una pieza audiovisual potente para comunicación corporativa",
        "• diferenciar su comunicación con contenido audiovisual propio de alto nivel",
      ],
    },
  ],
},
{
  slug: "real-madrid-riquelme",
  title: "Real Madrid",
  video: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/real-madrid-GlKHkeBrlqlhQb1fygPgJPFzTQ9fwt.mp4",
  poster: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/real-madrid-poster-EIinr0iPrvoeJinC3PnTAPIGYUD81Z.jpg",
  href: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/real-madrid-GlKHkeBrlqlhQb1fygPgJPFzTQ9fwt.mp4",
  sections: [
    {
      title: "",
      items: [
        "Enrique Riquelme presentó su candidatura a la presidencia del Real Madrid bajo el proyecto «Legado y Futuro», enfrentándose a Florentino Pérez en las primeras elecciones del club en casi 20 años.",
        "Mi misión fue dar forma audiovisual al mensaje central de la campaña — «El Real Madrid no se vende» — con una pieza vertical pensada para movilizar al socio madridista en redes.",
        "El resultado es un vídeo emocional y directo, construido sobre el sentimiento de pertenencia y la defensa de la identidad del club.",
      ],
    },
    {
      title: "EL OBJETIVO DEL PROYECTO",
      items: [
        "El vídeo tenía tres objetivos principales:",
        "✓ Transmitir el mensaje de campaña — «El Real Madrid no se vende»: pertenencia, legado y defensa del modelo de socios.",
        "✓ Movilizar al votante en redes — Una pieza vertical breve, emocional y compartible de cara a la jornada electoral.",
        "✓ Reflejar la seriedad del proyecto — Un acabado visual cuidado, con ritmo y tono institucional pero cercano.",
      ],
    },
    {
      title: "MI PAPEL EN EL PROYECTO",
      items: [
        "Me encargué de la producción audiovisual de la pieza, incluyendo:",
        "• dirección y enfoque narrativo del mensaje",
        "• grabación en 4K con cámara estabilizada",
        "• planos cerrados de carga emocional",
        "• edición ágil orientada a vertical (9:16)",
        "• ritmo de montaje pensado para redes",
        "• corrección de color",
        "• música y diseño sonoro acordes al tono de campaña",
        "• entrega optimizada para Instagram y redes sociales",
        "El objetivo clave: crear un vídeo que conecte de inmediato con el sentimiento del socio.",
      ],
    },
    {
      title: "PROCESO DE PRODUCCIÓN",
      items: [
        "Durante el proyecto:",
        "• traduje el eslogan de campaña a una narrativa visual clara",
        "• prioricé la emoción y la pertenencia sobre el discurso político",
        "• cuidé un montaje rápido para sostener la atención en feed",
        "• mantuve una estética coherente con la identidad de «Legado y Futuro»",
        "• adapté la pieza al formato vertical nativo de Instagram",
        "El resultado es un vídeo con fuerte carga emocional alineado con el mensaje de la candidatura.",
      ],
    },
    {
      title: "ENTREGA FINAL",
      items: [
        "El proyecto incluyó:",
        "1 vídeo principal de campaña. Edición vertical con narrativa clara y mensaje directo.",
        "Pieza optimizada para redes sociales. Formato 9:16 pensado para Instagram Reels.",
        "Corrección de color, música y diseño sonoro. Tratamiento visual coherente con la identidad de la campaña.",
      ],
    },
    {
      title: "RESULTADO",
      items: [
        "La pieza se publicó en el marco de la campaña electoral del Real Madrid 2026:",
        "• reforzó el mensaje «El Real Madrid no se vende»",
        "• generó conversación y alcance en redes",
        "• apoyó la movilización del voto del socio",
        "• mostró el valor de un mensaje claro contado en clave audiovisual",
      ],
    },
  ],
},
{
  slug: "cinesa",
  title: "Cinesa",
  video: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/cinesa-36LhsKhSkLDenX3JaZkxpiKz3V15R5.mp4",
  poster: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/cinesa-poster-1xiDgetIzToSl4xReEBWXtgVYEefDH.jpg",
  href: "https://kgtz1gujr7extokb.public.blob.vercel-storage.com/portfolio/cinesa-36LhsKhSkLDenX3JaZkxpiKz3V15R5.mp4",
  sections: [
    {
      title: "",
      items: [
        "Creamos un contenido audiovisual que captura la experiencia real del evento de Cinesa: ambiente, actividades, gente divirtiéndose y la esencia de un preestreno pensado para generar recuerdo de marca.",
        "Un aftermovie dinámico, cercano y orgánico, diseñado para redes sociales. No buscamos “la cámara perfecta”, sino transmitir energía, emoción y autenticidad.",
      ],
    },
    {
      title: "EL OBJETIVO DEL PROYECTO",
      items: [
        "El objetivo de esta producción fue reforzar el posicionamiento de Cinesa como una marca de ocio experiencial, moderna y cercana, conectando con su público a través de contenido real y emocional.",
        "• Mostrar la experiencia Cinesa más allá de la sala de cine",
        "• Capturar la interacción del público con las actividades",
        "• Reflejar el ambiente del evento y el disfrute de los asistentes",
        "• Poner en valor la propuesta gastronómica (menú y comidas)",
        "• Generar un contenido atractivo para redes sociales y comunicación digital",
      ],
    },
    {
      title: "MI PAPEL EN EL PROYECTO",
      items: [
        "Producción audiovisual integral enfocada a contenido de marca:",
        "• Dirección creativa del contenido",
        "• Grabación del evento",
        "• Captura de recursos visuales (ambiente, actividades, público, fotocall, menú)",
        "• Enfoque narrativo basado en experiencia",
        "• Edición del aftermovie final",
        "• Adaptación del contenido para redes sociales",
        "El objetivo fue construir un vídeo que no solo muestre el evento, sino que transmita la experiencia de haber estado allí.",
      ],
    },
    {
      title: "PROCESO DE GRABACIÓN",
      items: [
        "Durante la grabación se capturaron momentos clave del evento:",
        "• Actividades del preestreno",
        "• Dinámica de baloncesto",
        "• Interacción del público",
        "• Gente divirtiéndose",
        "• Zona de standing y fotocall",
        "• Detalles del menú y comida",
        "• Ambiente general del evento",
        "Condiciones técnicas:",
        "• Grabación de estilo natural y dinámico",
        "• Sin planos aéreos",
        "• Enfoque social-first (pensado para redes)",
        "• Cobertura total de la experiencia del evento",
      ],
    },
    {
      title: "ENTREGA FINAL",
      items: [
        "El entregable principal fue el aftermovie dinámico optimizado para redes sociales.",
        "Características del vídeo:",
        "• Ritmo ágil",
        "• Estilo fresco y cercano",
        "• Corrección básica de color",
        "• Formato listo para publicación en redes",
      ],
    },
    {
      title: "RESULTADO",
      items: [
        "El resultado permitió a Cinesa:",
        "• generar contenido atractivo para redes sociales",
        "• reforzar la percepción de marca experiencial",
        "• mostrar el valor diferencial de sus eventos",
        "• aumentar el engagement en canales digitales",
        "• disponer de material reutilizable para futuras comunicaciones",
      ],
    },
  ],
}
  // 👉 aquí metes los otros 7 proyectos
]

export type Project = (typeof projects)[number]

/** ¿Tiene el proyecto traducción en `lang`? (ES siempre) */
export function hasProjectTranslation(slug: string, lang: Lang): boolean {
  return lang === "es" || Boolean(projectTranslations[lang]?.[slug])
}

/**
 * Proyectos en el idioma pedido: se sustituyen título y secciones por la
 * traducción si existe; vídeo, póster y slug son siempre los mismos.
 * Sin traducción → contenido español.
 */
export function getProjects(lang: Lang): Project[] {
  if (lang === "es") return projects
  return projects.map((project) => {
    const translation = projectTranslations[lang]?.[project.slug]
    return translation ? { ...project, ...translation } : project
  })
}

export function getProject(slug: string, lang: Lang): Project | undefined {
  return getProjects(lang).find((project) => project.slug === slug)
}
